
import React from 'react';
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import MuiAutocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Chip, Paper, Popper, styled, SxProps } from "@mui/material";
import { GoChevronDown } from "react-icons/go";

const icon = (
  <CheckBoxOutlineBlankIcon fontSize="small" style={{ borderRadius: 4 }} />
);
const checkedIcon = (
  <CheckBoxIcon
    style={{ backgroundColor: "#FF5C39", color: "#fff", borderRadius: 4 }}
    fontSize="small"
  />
);

const WhiteBorderTextField = styled(TextField)`
  & label.Mui-focused {
    color: grey;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: #e5e7eb;
    }
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: #e5e7eb;
      }
    }
  }
`;
// Styled Paper Component for custom dropdown styles
const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
  maxHeight: 400,
  width: "100%",
  padding: 4,
  backgroundColor: theme.palette.background.paper,
}));


// Fixed Popper with correct positioning logic
// const CustomPopper = (props) => {
//   return (
//     <Popper
//       {...props}
//       sx={{ mt: 2 }}
//     />
//   );
// };
export interface Option {
  label: string;
  id: number;
  value?: string;
  groupBy?: string;
}

interface CustomAutocompleteProps extends Omit<AutocompleteProps<Option, true, false, false, "div">, 'renderInput'> {
  renderOptionLabel?: boolean;
  textFieldSx: SxProps;
  padding?: number | string;
  minWidth?: number | { xs?: string | number; sm?: string | number; md?: string | number; lg?: string | number };
  label: string;
  groupBy?: (option: Option) => string;
  renderInput?: (params: any) => JSX.Element; // Now optional
}


export default function Autocomplete({ label, options, minWidth, getOptionLabel, renderOptionLabel = false, textFieldSx, padding, renderInput, ...props }: CustomAutocompleteProps) {
  // const handleLabels = (option) => {
  //   return option.value || option.title || "Unknown";
  // };
  // function CustomPopper(props:any) {
  //   return (
  //     <Popper
  //       {...props}
  //       placement="bottom-start"
  //       sx={{
  //         padding: padding || 'auto',
  //         '& .MuiAutocomplete-listbox': {
  //           padding: '0px',
  //         },
  //         '& .MuiAutocomplete-paper': {
  //           margin: 0,
  //           fontSize: '13px',
  //           padding: '0px',

  //         }
  //       }}
  //     />
  //   );
  // }

  const uniqueId = `autocomplete-${label}-filter`;
  const maxTags = 1 // Limit the number of visible tags
  return (
    <MuiAutocomplete
      multiple
      id={`checkboxes-tags-demo-${label}`}
      options={options || []}
      popupIcon={<GoChevronDown aria-label='GoChevronDown-svg' size={16} />}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      renderInput={(params) => (
        <WhiteBorderTextField
          {...params}
          id={uniqueId} // Set a unique ID
          InputLabelProps={{
            "aria-label": `${label}-label`, // Add aria-label directly to the label element
          }}
          InputProps={{
            ...params.InputProps,
            style: { maxHeight: 60, paddingRight: 23 }, // Fixed height and right padding
          }}
          sx={{
            minWidth, ...textFieldSx,
            "& .MuiInputLabel-root": {
              // mt: "1.5px",
              fontSize: 20
            },
          }}
          label={label}
          
          aria-labelledby={`${label}-id`} // Use aria-labelledby to link the label to the input
        />
      )}
      isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
      renderOption={(props, option, { selected }, index) => {
        const { key, ...optionProps } = props;
        if (option.label !== option.groupBy) {
          return (
            <li key={`${index} ${option.id}`} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                sx={{ marginRight: 1 }} // Using sx for margin
                checked={selected}
              />
              {option.label}
            </li>
          );
        }
      }}

      renderTags={(options, getTagProps) => {
        const displayedTags = options.slice(0, maxTags); // Only display the first few tags

        return [
          ...displayedTags.map((option, index) => (
            <Chip
              // key={`${index} ${option.id}` || option.value || option.label || option.title}
              label={option.label}
              {...getTagProps({ index })}
              style={{ backgroundColor: "#F8F8F8", maxWidth: "60%", opacity: index > maxTags ? 0 : 1 }}
            />
          )),
          options.length > maxTags && (
            <Chip
              key="more"
              label={`${options.length - maxTags} more`}
              style={{
                backgroundColor: "#FF5C3926",
                color: "#FF5C39",
                fontWeight: 500,
              }}
            />
          ),
        ];
      }}
      slotProps={{
        paper: {
          sx: {
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
            maxHeight: 400,
            minWidth: 200,
            backgroundColor: theme => theme.palette.background.paper, // Access the theme
          },
        },
        popper: {
          placement: "bottom-start",
          sx: {
            padding: padding || 'auto',
            '& .MuiAutocomplete-listbox': {
              padding: '0px',
            },
            '& .MuiAutocomplete-paper': {
              margin: 0,
              fontSize: '13px',
              padding: '0px',

            }
          }

        }
      }}

      // PopperComponent={CustomPopper} // Attach custom Popper for alignment
      {...props}
    />
  );
}
